export interface Choice {
	id: string | number;
	name: string | number;
}

export const toChoice = (name: string | number) => ({ id: name, name });